import { Dispatch } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  LeftToLine,
  RightToLine,
} from '@unified-checkout/design-system/icons/index';
import { mainNavLinks } from 'apps/customer/src/constants';
import { OneClick, SmallOneClick } from 'apps/customer/src/assets/icons';
import { NavItem } from '../navItem';
import styles from './side-menu.module.scss';
import { UserInfo } from '../UserInfo';

export interface ISideMenuProps {
  isSideMenuCollapsed: boolean;
  setIsSideMenuCollapsed: Dispatch<boolean>;
}
export const SideMenu = ({
  isSideMenuCollapsed,
  setIsSideMenuCollapsed,
}: ISideMenuProps) => {
  const navigate = useNavigate();
  const pathname = useLocation();

  const collapseBtnClickHandler = () => {
    setIsSideMenuCollapsed(!isSideMenuCollapsed);
  };

  const logoClickHandler = () => {
    navigate('/payment-method');
  };

  return (
    <aside
      className={styles['side-menu']}
      data-side-menu-collapsed={isSideMenuCollapsed}
    >
      <div
        className={styles['side-menu__collapse-expand-btn']}
        onClick={collapseBtnClickHandler}
      >
        {isSideMenuCollapsed ? RightToLine : LeftToLine}
      </div>

      <div className={styles['side-menu__logo']} onClick={logoClickHandler}>
        {isSideMenuCollapsed ? SmallOneClick : OneClick}
      </div>
      <UserInfo isSideMenuCollapsed={isSideMenuCollapsed} />
      <div className={styles['side-menu__nav-links']}>
        {mainNavLinks.map((navLink) => {
          return (
            <NavItem
              key={navLink.route}
              icon={navLink.icon}
              label={navLink.label}
              route={navLink.route}
              active={pathname.pathname === navLink.route}
              collapsed={isSideMenuCollapsed}
            />
          );
        })}
      </div>
    </aside>
  );
};
